import { nanoid } from 'nanoid';
import React, { useRef } from 'react';
import NumberFormat from 'react-number-format';

import TextInput from 'components/digifi-wrappers/TextInput';
import { TextInputPropsSingleLine } from 'product_modules/components/TextInput';

type MonetaryInputProps = Omit<
  TextInputPropsSingleLine,
  'ref' | 'defaultValue' | 'type' | 'onChange' | 'value' | 'name' | 'id' | 'autoComplete'
> & {
  value: number | null;
  onChange: (value: number | null) => void;
};

const MAX_DECIMAL_PART_LENGTH = 2;
const INPUT_PREFIX = '$ ';

const MonetaryInput = ({ onChange, ...props }: MonetaryInputProps) => {
  const handleChange = (values: { floatValue?: number }) => {
    onChange(values.floatValue ?? null);
  };

  //Unique autoComplete value to prevent browser from autofilling the field
  const uniqueId = useRef(nanoid());

  return (
    <NumberFormat
      name={uniqueId.current}
      id={uniqueId.current}
      autoComplete={uniqueId.current}
      prefix={INPUT_PREFIX}
      decimalScale={MAX_DECIMAL_PART_LENGTH}
      isNumericString
      thousandSeparator
      customInput={TextInput}
      onValueChange={handleChange}
      placeholder={INPUT_PREFIX}
      allowNegative={false}
      {...props}
    />
  );
};

export default MonetaryInput;
